/**
 * Notches: notch-line progress. One 2px stroke per unit, seal when done, rule when not; the next one can be marked
 * ochre (waiting on you). Shown to screen readers as one image with a label ("18 of 25 sent").
 * Above `max` units the strokes are scaled down to `max` so the bar stays short (the label keeps the real figures).
 */
export function Notches({ done, total, label, next = false, max = 40, height = 14 }: { done: number; total: number; label: string; next?: boolean; max?: number; height?: number }) {
  const t = Math.max(0, Math.floor(total));
  const d = Math.max(0, Math.min(Math.floor(done), t));
  const shown = Math.min(t, max);
  const lit = t === 0 ? 0 : Math.round((d / t) * shown);
  return (
    <span className="notches" role="img" aria-label={label} style={{ height }}>
      {Array.from({ length: shown }, (_, i) => (
        <span key={i} className={`notch${i < lit ? " is-done" : next && i === lit ? " is-next" : ""}`} />
      ))}
    </span>
  );
}
